import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeIssuePlaceCommand extends BaseCommand {
  CommandName = "ChangeIssuePlace";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
